import { render, staticRenderFns } from "./port-load.vue?vue&type=template&id=16defe46&scoped=true&"
import script from "./port-load.vue?vue&type=script&lang=js&"
export * from "./port-load.vue?vue&type=script&lang=js&"
import style0 from "./port-load.vue?vue&type=style&index=0&id=16defe46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16defe46",
  null
  
)

export default component.exports